import { useEffect, useState } from 'react';
import { useScript } from './useScriptHook';

export const useGoogleMapsScriptTag = () => {
  const [hasCalledBack, setHasCalledBack] = useState(false);

  useEffect(() => {
    let mounted = true;

    // if maps isnt already loaded
    if (!window?.google?.maps) {
      const { googleMapsCallback } = window as any;
      (window as any).googleMapsCallback = () => {
        mounted && setHasCalledBack(true);
        googleMapsCallback && googleMapsCallback();
      };
    }

    return () => {
      mounted = false;
    };
  }, []);

  const [loaded, scriptError] = useScript(
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyCcgOjQXPZ-naWT-ymRgWViZGun8_bn7sc&libraries=places&callback=googleMapsCallback'
  );

  const hasBeenInitialized = window?.google?.maps || hasCalledBack;
  const canShowAddAddressInput = hasBeenInitialized && loaded && !scriptError;

  return [canShowAddAddressInput, scriptError];
};
